export { getRoutingAdapter } from './next-routing-adapter'
